import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Close from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';
import { Chart, ArcElement, BarElement, CategoryScale, LinearScale } from 'chart.js';
import {Pie, Bar} from 'react-chartjs-2';
import {
  Dialog,
  Grid
} from '@material-ui/core';
import {  fetchTrackingReports } from '../../services/api';
import './style.css'

Chart.register(ArcElement, BarElement, CategoryScale, LinearScale);
function TrackingReports(props) {
  const {
    patient = {},
    closeDialog,
    open,
    classes: {
      appBar,
      title,
    }
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [barChartValues, setBarChartValues] = useState([200, 23, 57]);
  const [pieChartValues, setPieChartValues] = useState([23, 45, 67])


  useEffect(() => {
    (async () => {
      try {
         const {data }= await fetchTrackingReports(patient.id);
          let pData = [data.CompletedCount,data.trackedCount, data.untaggedCount, ];
         let bData = [data.countlastBeforeMonth, data.countLastMonth, data.countCurrentMonth];
         setBarChartValues(bData);
         setPieChartValues(pData);
         
       } catch (err) {
        console.error(err);
       }
    })();
  }, []);

 
const barChartData = {
    labels: [ 'Before Last Month', 'Last Month', 'This month',  ],
    datasets: [
      {
        label: 'Requests',
        backgroundColor: '#ff9466',
        borderColor: '#d3661d',
        borderWidth: 1,
        hoverBackgroundColor: '#d3661d',
        hoverBorderColor: '#030303',
        data: barChartValues
      }
    ]
  };

  const pieChartdata = {
	labels: [
		'Total Patients',
		'Tracking Patients',
		'untagged Patients',

 ],
	datasets: [{
			labels: [
 
 ],
		data:pieChartValues,
		backgroundColor: ["#59ccb3", '#5e98ba', '#e8814a'] ,
		width:80,
		height:200,
 
	}],
 };

  
 
  return (
    <FullScreenDialog
      fullScreen={open}
      open={open}
      onClose={closeDialog}
    >
      <AppBar color="default" className={appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={title}>
            Track New Patient
          </Typography>

          <Button color="inherit" onClick={closeDialog}>
            <Close />
          </Button>
        </Toolbar>

      </AppBar>
      <Grid container  alignItems="center">
          <Grid item  xs={12} md={6} lg={6}>
      <div className="custom-border-line">
              <Pie data={pieChartdata}    
                   
				   />
      </div>
      </Grid>
      <Grid item  xs={12} md={6} lg={6}>
    <div className="custom-border-line">
         <Bar
          data={barChartData}
          width={100}
          height={253.5}
          options={{
            maintainAspectRatio: false
          }}
        />
      </div>
      </Grid>
      </Grid>
    </FullScreenDialog>
  );
}

TrackingReports.propTypes = {
  patient: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

const styles = () => ({
  appBar: {
    position: 'relative',
  },
  customTextArea: {
    width: '100%'
  },
  customBtn: {
    width: '15%',
    margin: '20px auto',
    display: 'block'
  },
  customFileUpload: {
    display: 'inline-block',
    backgroundColor: '#505d68',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: '0.3rem',    
    cursor: 'pointer',
    marginTop: '1rem'
  },
  customDatePicker: {
    position:'relative'
  },
  customSelect: {
    width: '85%'
  },
  customFormGroup: {
    flexDirection:'row'
  },
  wholeSection: {
    padding: '0 30px'
  },
  customText: {
    width: '85%',
    marginTop:'10%'
  },
  formControl: {
    marginTop: '20px',
    width: '100%'

  },
  customLabel: {
    fontSize: '20px',
    marginBottom: '15px',
    color: '#000 !important',
    display: 'block',
    marginTop: '20px'
  },
  title: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

const fullScreenDialogStyles = theme => ({
  paperFullScreen: {
    width: '55%',
    height: '80%',
    position: 'fixed',
    bottom: '0',
    [theme.breakpoints.down('lg')]: {
      width: '80%',
    },
  },
});

const FullScreenDialog = withStyles(fullScreenDialogStyles)(Dialog);

export default withStyles(styles)(TrackingReports);
